export default __webpack_public_path__ + "static/media/Ntorq125Racing_Posterior.84d10235.webp";